import { useQuery } from 'react-query';
import { onboardingRecordService } from '@/services/onboardingRecordService';

/**
 * Quantos registros de onboarding foram enviados e ainda não foram onboardados.
 * `enabled` é obrigatório porque a sidebar renderiza para todos e a rota é
 * Supervisor+ — chamar sem permissão gera 403 em toda navegação.
 */
export function useOnboardingQueueCount(enabled: boolean): number {
  const { data = [] } = useQuery(
    ['onboarding-records', 'enviado'],
    () => onboardingRecordService.list('enviado'),
    { enabled, staleTime: 60_000, refetchOnWindowFocus: true },
  );
  return data.length;
}
